const { BUCKET_IMAGES_URL, WARNING_ICON_SVG } = require('./utils/constants');
// core framework functions  --------------------------
Element.prototype.addELM = function(object) {
  let elm = object;
  let appended;
  while (elm && elm.getHTML && !(elm instanceof Element)) {
    elm = elm.getHTML();
  }

  if (elm) appended = this.appendChild(elm);
  return appended;
};

Element.prototype.insertELM = function(object) {
  // Insert into top of stack
  let elm = object;
  while (elm && elm.getHTML && !(elm instanceof Element)) {
    elm = elm.getHTML();
  }

  let firstChild = this.firstChild;
  if (elm) {
    if (firstChild) {
      return this.insertBefore(elm, firstChild);
    } else {
      return this.appendChild(elm);
    }
  }
};

Element.prototype.addBefore = function(object) {
  // Insert into top of stack
  let elm = object;
  while (elm && elm.getHTML && !(elm instanceof Element)) {
    elm = elm.getHTML();
  }

  const parent = this.parentNode;
  if (elm) {
    return parent.insertBefore(elm, this);
  }
};

Element.prototype.removeELM = function(object) {
  let elm = object;
  if (object.destroy) {
    object.destroy();
  }
  if (object.getELM) {
    elm = object.getELM();
  }
  return this.removeChild(elm);
};

window.getDom = document.querySelector.bind(document);

const unique = function(arr) {
  return arr.filter(function(value, index, self) {
    return self.indexOf(value) === index;
  });
};

Math.easeInOutQuad = function(t, b, c, d) {
  t /= d / 2;
  if (t < 1) return (c / 2) * t * t + b;
  t--;
  return (-c / 2) * (t * (t - 2) - 1) + b;
};

function cELM(tag, classes, innerHTML, style, id) {
  let e = document.createElement(tag);
  if (classes) {
    e.className = classes;
  }

  if (innerHTML) {
    e.innerHTML = innerHTML;
  }

  if (style) {
    e.setAttribute('style', style);
  }

  if (id) {
    e.id = id;
  }

  return e;
}

function isMobile() {
  var check = false;
  (function(a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a,
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4),
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
}

function guidGenerator() {
  const S4 = function() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  };

  return S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4();
}

function getParameterByName(name, url) {
  if (!url) url = window.location.href;

  if (url.indexOf("?") === -1) return null;
  let data = url.split("?").pop();
  let value = null;
  data.split("&").forEach(function(pm) {
    if (pm.indexOf(name + "=") === 0) {
      value = pm.split(name + "=").pop();
    }
  });

  return value;
}

function getChatURL() {
  if (process.env.MOBILE_APP) {
    let uid = getParameterByName('uid');
    return uid;
  }

  let url = window.location.href;
  url = url.split("?")[0];

  let parts = url.split("/");
  let lastPart = parts.pop();

  return lastPart;
}

function getWindowHeight() {
  return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
}

function getWindowWidth() {
  return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
}

function getKioskURL(type){
  //ex: :https://checkin-devqa-au.healthnote.co/home?message=complete
  let kioskULR = window.KIOSK_URL;
  let chatID = getChatURL();

  let url = kioskULR || '';
  url = url.split("?")[0];

  if(window.KIOSK_URL_FULLPATH){
    if(url.indexOf('?') == -1){
        return window.KIOSK_URL_FULLPATH + '?uid=' + chatID;
    }
    else
    {
      return window.KIOSK_URL_FULLPATH + '&uid=' + chatID;
    }
  }
  else
  {
    let parts = url.split("/");
    parts[parts.length - 1] = ('error?uid=' + chatID);

    return parts.join("/");
  }

}

function sendMessageToWebView(event, msg) {
  if (!process.env.MOBILE_APP) {
    return;
  }

  if (window.webkit && window.webkit.messageHandlers[event]) {
    window.webkit.messageHandlers[event].postMessage(msg);
  }
}

function goToKiosk(msg) {
  if (process.env.MOBILE_APP) {
    sendMessageToWebView('openKiosk', msg || {});
    return;
  }
  location.href = getKioskURL();
}

function debounce(func, wait, immediate) {
  let timeout;

  return function executedFunction() {
    let context = this;
    let args = arguments;

    let later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    let callNow = immediate && !timeout;

    clearTimeout(timeout);

    timeout = setTimeout(later, wait);

    if (callNow) func.apply(context, args);
  };
}

function httpGet(url, data, onSuccess, onError) {
  let paramArray = ["dt=" + new Date().valueOf().toString()];

  Object.keys(data).forEach(kk => {
    paramArray.push([kk, data[kk]].join("="));
  });

  url = url + "?" + paramArray.join("&");

  fetch(url)
    .then(data => {
      return data.json();
    })
    .then(onSuccess)
    .catch(onError);
}

function get(obj, path, def = null) {
  const paths = path.split(".");
  let temp = JSON.parse(JSON.stringify(obj));

  for (var p in paths) {
    temp = temp[paths[p]];
    if (!temp) return def;
  }

  return temp;
}

function Wrap4Arrow(inputEl, isDefaultActive, loseFocusOnBlur) {
  const wrapper = cELM("div", "arrow-target");
  if (isDefaultActive) {
    wrapper.classList.add("arrow-active");
  }

  inputEl.onfocus = function(evt) {
    evt.target.parentNode.classList.remove("arrow-active");
  };

  // AR we remove this manually at the component level since some places the arrow need to remain
  if (loseFocusOnBlur) {
    inputEl.onblur = function(evt) {
      //AR: this get's ran automatically sometime
      evt.target.parentNode.classList.remove("arrow-active");
    };
  }

  let img = cELM("img", "arrow");
  img.src = `${BUCKET_IMAGES_URL}/ui-assets/arrow.svg`;

  wrapper.point = function(bool){
    if(bool){
      this.classList.add("arrow-active");
    }
    else
    {
      this.classList.remove("arrow-active");
    }
  }
  wrapper.addELM(inputEl);
  wrapper.addELM(img);

  return wrapper;
}

function Wrap4ArrowRight(inputEl, isDefaultActive, loseFocusOnBlur) {
  const wrapper = cELM("div", "arrow-target");
  if (isDefaultActive) {
    wrapper.classList.add("arrow-active");
  }

  inputEl.onfocus = function(evt) {
    evt.target.parentNode.classList.remove("arrow-active");
  };

  // AR we remove this manually at the component level since some places the arrow need to remain
  if (loseFocusOnBlur) {
    inputEl.onblur = function(evt) {
      //AR: this get's ran automatically sometime
      evt.target.parentNode.classList.remove("arrow-active");
    };
  }

  let img = cELM("img", "arrow arrow-right");
  img.src = `${BUCKET_IMAGES_URL}/ui-assets/arrow.svg`;

  wrapper.point = function(bool){
    if(bool){
      this.classList.add("arrow-active");
    }
    else
    {
      this.classList.remove("arrow-active");
    }
  }
  wrapper.addELM(inputEl);
  wrapper.addELM(img);

  return wrapper;
}

function Wrap4ArrowMulti(inputEl, isDefaultActive) {
  const wrapper = cELM("div", "arrow-target");
  if (isDefaultActive) {
    setTimeout(() => {
      inputEl.focus();
    });

    wrapper.classList.add("arrow-active");
  }

  inputEl.onfocus = function(evt) {
    evt.target.parentNode.classList.add("arrow-active");
  };

  inputEl.onblur = function(evt) {
    //AR: this get's ran automatically sometime
    evt.target.parentNode.classList.remove("arrow-active");
  };

  let img = cELM("img", "arrow");
  img.src = `${BUCKET_IMAGES_URL}/ui-assets/arrow.svg`;

  wrapper.addELM(inputEl);
  wrapper.addELM(img);

  return wrapper;
}

function isNoneOfTheAbove(inputVal = '') {
    inputVal = inputVal.toLowerCase()
    return (window.getLngTxt('none of the above') || []).indexOf(inputVal) > -1
}

/**
 * Determines if an option is equivalent to "none of the above"
 * @param {object} option
 * @returns
 */
const isNone = (option) => {
  if (option.optionType === 'NONE_OF_THE_ABOVE') {
    return true;
  }

  const optionValue = option.name || option.value;

  return isNoneOfTheAbove(optionValue);
};

//AR: Hard code for now since there are not that many values this will be loaded from backend at some point
window.LanguageText = {
  "eng":{
    "scrollmore":"Scroll Down or Tap this",
    "button.go":"Go",
    "button.other":"Other",
    "button.continue":"Continue",
    "button.clear":"Clear",
    "button.submit":"Submit",
    "button.edit":"Edit",
    "button.delete": "Delete",
    "button.yes": "Yes",
    "button.no": "No",
    "button.retake": "Retake",
    "button.takeOrUpload": "Take or upload picture",
    "button.skip": "Skip",
    "button.done": "Done",

    "popup.edit.title":"Edit answer?",
    "popup.edit.content":"This will delete any answers after it.",
    "popup.edit.medication.title": "Update medications?",
    "popup.edit.medication.content": "This will update your current medications.",
    "popup.edit.allergy.title": "Update allergy?",
    "popup.edit.allergy.content": "This will update your selected allergy.",
    "popup.delete.medication.title": "Delete",
    "popup.delete.medication.content": "Are you sure you want to delete this medication?",
    "popup.delete.allergy.title": "Delete",
    "popup.delete.allergy.content": "Are you sure you want to delete this allergy?",

    "button.ok":"OK",
    "button.cancel":"Cancel",

    "input.placeholder.type":"Tap here to type",
    "input.placeholder.firstname":"First Name",
    "input.placeholder.lastname":"Last Name",
    "input.placeholder.name":"Tap here to type full name",
    "input.placeholder.number":"Enter Number",
    "input.placeholder.money":"Tap here to enter amount",
    "input.placeholder.tel":"Phone Number",
    "input.placeholder.email":"Email",
    "input.placeholder.number.add":"Add Number",

    "input.placeholder.fulladdress":"Full Address",
    "input.placeholder.address":"Street Address",
    "input.placeholder.apartmentunit":"Apt",
    "input.placeholder.city":"City",
    "input.placeholder.state":"State",
    "input.placeholder.postalcode":"Zip",

    "input.signature":"Use your mouse or finger to sign",
    "input.signature.error":"Unable to read signature, please try again",
    "none of the above": [
      "none",
      "none of the above",
      "decline to answer",
      "skip",
      "not sure",
      "never",
      "unknown",
      "unsure",
      "nothing",
      "no obvious cause",
    ],
    "placeholder.day": "Day",
    "placeholder.year": "Year",
    "placeholder.month": "Month",

    "medication.yesToAll": "Yes to all medications",
    "medication.day": "day",

    "insurance.DONTKNOW": "i'm not sure",
    "insurance.OTHER": "show more insurances",

    "imageUpload.blurry": "Your picture could not be read.",
    "imageUpload.slightlyBlurry": "Your picture is difficult to read.",
    "imageUpload.blurrySubtext": "Please tap Retake and try again.",
    "imageUpload.takePicture": "Take Picture",
    "imageUpload.cameraFeedText": "Try to center the card's corners within the white marks & tap Take Picture.",
    "imageUpload.cameraFeedSubtext": "Hint: Set the card on a table if your picture looks blurry.",
    "imageUpload.couldntProcess": "The image could not be processed. Please try again.",
    "imageUpload.unsupportedFileType": "Unsupported file type.",
    "imageUpload.instructionsText": "Try to center the card against a dark background and make sure all four corners are visible."
  },
  "vie":{
    "scrollmore":"Đi xuống nữa",
    "button.go":"Đi tiếp",
    "button.other":"Other",
    "button.continue":"Tiếp tục",
    "button.clear":"Xóa bỏ",
    "button.submit":"Gửi đi",
    "button.edit":"Sửa đổi",

    "popup.edit.title":"Đổi ngôn ngữ",
    "popup.edit.content":"Chọn đổi ngôn ngữ sẽ xóa hết tất cả các câu trả lời vừa ghi vào.",
    "button.ok":"Đồng ý",
    "button.cancel":"Không đổi",

    "input.placeholder.type":"Nhấn vào đây",
    "input.placeholder.name":"Nhấn vào tên và họ của bạnh",
    "input.placeholder.number":"Nhấn số",
    "input.placeholder.money":"Nhấn vào đây để nhập số tiền",
    "input.placeholder.tel":"Nhấn số điện thoại",
    "input.placeholder.email":"Nhấn địa chỉ email",
    "input.placeholder.number.add":"Nhấn thêm số",

    "input.placeholder.fulladdress":"Nhấn địa chỉ liên lạc",
    "input.placeholder.address":"Số địa chỉ đường",
    "input.placeholder.apartmentunit":"Số căn hộ",
    "input.placeholder.city":"Thành phố",
    "input.placeholder.state":"Tiểu bang",
    "input.placeholder.postalcode":"Số bưu chính",

    "input.signature":"Dùng ngón tay để ký",
    "input.signature.error":"Unable to read signature, please try again", // Better to show something, we'll translate later
    "none of the above": []
  },
  "zho":{
    "scrollmore":"向下滾動或點按此",
    "button.go":"完成",
    "button.other":"Other",
    "button.continue":"繼續",
    "button.clear":"擦寫",
    "button.submit":"完成",
    "button.edit":"更改",

    "popup.edit.title":"更改?",
    "popup.edit.content":"在這之後。這將刪除所有答案",
    "button.ok":"好",
    "button.cancel":"取消",

    "input.placeholder.type":"點按此處輸入",
    "input.placeholder.name":"輸入英文名稱",
    "input.placeholder.number":"輸入號碼",
    "input.placeholder.money":"點擊此處輸入金額",
    "input.placeholder.tel":"電話號碼",
    "input.placeholder.email":"電子郵件地址",
    "input.placeholder.number.add":"加號碼",

    "input.placeholder.fulladdress":"完整地址",
    "input.placeholder.address":"街道地址",
    "input.placeholder.apartmentunit":"公寓號碼",
    "input.placeholder.city":"城市",
    "input.placeholder.state":"州",
    "input.placeholder.postalcode":"郵政編碼",

    "input.signature":"用鼠標或手指簽名",
    "input.signature.error":"Unable to read signature, please try again", // Better to show something, we'll translate later
    "none of the above": []
  },
  "spa":{
    "scrollmore":"Deslice o pulse aquí",
    "button.go":"Go",
    "button.other":"Otro",
    "button.continue":"Continuar",
    "button.clear":"Borrar",
    "button.submit":"Enviar",
    "button.edit":"Editar",
    "button.delete": "Eliminar",
    "button.yes": "Si",
    "button.no": "No",
    "popup.edit.title":"Editar respuesta?",
    "popup.edit.content":"Esto borrará todas las respuestas desde este punto",
    "popup.edit.medication.title": "¿Desea actualizar su medicación?",
    "popup.edit.medication.content": "Esto actualizará su medicación actual.",
    "popup.edit.allergy.title": "¿Desea actualizar su alergia?",
    "popup.edit.allergy.content": "Esto actualizará su alergia actual.",
    "popup.delete.medication.title": "Eliminar",
    "popup.delete.medication.content": "¿Está seguro de que desea eliminar esta medicación?",
    "popup.delete.allergy.title": "Eliminar",
    "popup.delete.allergy.content": "¿Está seguro de que desea eliminar esta alergia?",
    "button.ok":"OK",
    "button.cancel":"Cancelar",
    "button.retake": "Tomar nuevamente",
    "button.takeOrUpload": "Tomar o subir imagen",
    "button.skip": "Omitir",
    "button.done": "Hecho",

    "input.placeholder.type":"Presione aquí para escribir",
    "input.placeholder.name":"Presione aquí para escribir su nombre completo",
    "input.placeholder.number":"Ingrese número",
    "input.placeholder.money":"Presione aquí para escribir el monto",
    "input.placeholder.tel":"Número de teléfono",
    "input.placeholder.email":"Correo electrónico",
    "input.placeholder.number.add":"Agregue número",

    "input.placeholder.fulladdress":"Dirección completa",
    "input.placeholder.address":"Dirección",
    "input.placeholder.apartmentunit":"Departamento",
    "input.placeholder.city":"Ciudad",
    "input.placeholder.state":"Estado",
    "input.placeholder.postalcode":"Código postal",

    "input.signature":"Use el mouse o su dedo para firmar",
    "input.signature.error":"No se pudo procesar la firma, por favor intente nuevamente",
    "none of the above": [
      "ninguna",
      "ninguna de las anteriores",
      "ninguno de las anteriores",
      "ninguno de los anteriores",
      "ninguno aplica",
      "no estoy seguro",
      "desconocido",
      "me niego a contestar",
      "omitir",
      "no sé",
      "no lo sé",
      "no se",
      "nose",
      "nunca",
      "desconozco",
      "nada",
      "sin causa aparente"
    ],
    "placeholder.day": "Día",
    "placeholder.year": "Año",
    "placeholder.month": "Mes",
    "medication.yesToAll": "Si para todos los medicamentos",
    "medication.day": "día",

    "insurance.DONTKNOW": "no estoy seguro",
    "insurance.OTHER": "mostrar más seguros",

    "imageUpload.blurry": "La imagen no se pudo leer.",
    "imageUpload.slightlyBlurry": "Es dificil leer su imagen.",
    "imageUpload.blurrySubtext": "Por favor presione Tomar nuevaamente e intente de nuevo.",
    "imageUpload.takePicture": "Tomar foto",
    "imageUpload.cameraFeedText": "Intenta centrar las esquinas de la tarjeta dentro de las marcas blancas y presiona Tomar foto.",
    "imageUpload.cameraFeedSubtext": "Sugerencia: pon la tarjeta sobre una mesa si la foto se ve borrosa.",
    "imageUpload.couldntProcess": "No se pudo procesar la imagen. Inténtelo nuevamente.",
    "imageUpload.unsupportedFileType": "Tipo de archivo no soportado.",
    "imageUpload.instructionsText": "Intente capturar la credencial contra un fondo oscuro y asegúrese de que las cuatro esquinas estén visibles."
  }
}
window.getLngTxt = function(key){

  if(window.CHATBOT_LANGUAGE && window.LanguageText[window.CHATBOT_LANGUAGE] && window.LanguageText[window.CHATBOT_LANGUAGE][key])
    return window.LanguageText[window.CHATBOT_LANGUAGE][key];
  else
    return window.LanguageText["eng"][key]
}

// Convert canvas dataURI to blob
function dataURItoBlob(dataURI) {
  var binary = atob(dataURI.split(',')[1]);
  var array = [];
  for(var i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
  }

  return new Blob([new Uint8Array(array)], {type: 'image/png'});
}

// C.A: Create a css class name based on the variable / answerKey attribute
function getAnswerVariableCssClass(data) {
  data = data || {};
  const dataValues = data.values || {}
  const variableKey = data.variable || data.answerKey || dataValues.variable || dataValues.answerKey || '';

  if(!variableKey) {
    return '';
  }

  return `v-${variableKey}`;
}

function getQuestionTestId(question) {
    if (!question) {
        return;
    }
    if (question.variable) {
        return `question-${question.variable}`;
    }
    if (question.answerKey) {
        return `question-screener-${question.answerKey}`;
    }
    if (question.format === 'end') {
        return 'question-end';
    }
}

function getQuestionAnswerTestId(question, answer) {
    if (!answer) {
        return;
    }
    const questionTestId = getQuestionTestId(question)
    if (!questionTestId) {
        return;
    }
    return `${questionTestId}-answer-${answer}`;
}

const globalCollabProvidersState = {};

function createCircuitBreakMessage() {
  const wrapper = cELM('div', '');

  const message = cELM('div', 'circuit-break-message');
  message.innerHTML = `${WARNING_ICON_SVG}<span>You caught us during a scheduling rush. Appointment times are available, but we’re having trouble showing them right now. Please refresh in a minute or two.</span>`;

  const refreshBtn = cELM('div', 'circuit-break-refresh-btn');
  refreshBtn.textContent = 'Refresh';
  refreshBtn.onclick = () => window.location.reload();

  wrapper.appendChild(message);
  wrapper.appendChild(refreshBtn);

  return wrapper;
}

module.exports = {
  cELM,
  isMobile,
  guidGenerator,
  getChatURL,
  getKioskURL,
  getParameterByName,
  getWindowHeight,
  getWindowWidth,
  debounce,
  httpGet,
  get,
  unique,
  Wrap4Arrow,
  Wrap4ArrowMulti,
  isNoneOfTheAbove,
  isNone,
  Wrap4ArrowRight,
  dataURItoBlob,
  sendMessageToWebView,
  goToKiosk,
  getAnswerVariableCssClass,
  getQuestionTestId,
  getQuestionAnswerTestId,
  globalCollabProvidersState,
  createCircuitBreakMessage,
};
